const LocationDetails = () => {
  return (
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1016.6919430606335!2d85.76009130846823!3d20.269810845271742!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19a9d597420753%3A0x36a22530210d699d!2sCovenant%20Developers!5e0!3m2!1sen!2sin!4v1755418298519!5m2!1sen!2sin"
      width="100%"
      height="450"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  );
};

export default LocationDetails;